export const latestTosVersion = "terms_of_service_2021-10-24.pdf";
